export function joinAddress(contact: {
  street: string;
  suite: string;
  city: string;
  state: string;
  zip_code: string;
}): string {
  return [
    contact.street,
    contact.suite,
    contact.city,
    [contact.state, contact.zip_code]
      .filter((x): x is string => Boolean(x && x.trim()))
      .join(' '),
  ]
    .filter((x): x is string => Boolean(x && x.trim()))
    .join(', ');
}

export function formatAddress(
  address: {
    street?: string | null;
    city?: string | null;
    state?: string | null;
    zip_code?: string | null;
    country?: string | null;
  } | null,
): string {
  if (!address) return '';
  const { street, city, state, zip_code, country } = address;

  const line1 = street ?? '';
  const line2 = [city, state].filter(Boolean).join(', ');
  const line3 = zip_code ?? '';
  const line4 = country ?? '';

  // remove empty lines
  return [line1, line2, line3, line4].filter(Boolean).join('\n');
}
